import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import { ItemsToBringListing } from 'types/listing/listings'

// get items to bring
const getItemsToBring = async (params?: { organizationId: string }) => {
  const response = await axiosGet(`v1/items-to-bring`, params)
  return response.data
}

export const useGetItemsToBring = (params?: { organizationId: string }) => {
  const itemsToBring = useQuery<ItemsToBringListing[]>(
    ['items-to-bring-list'],
    () => getItemsToBring(params),
    // getItemsToBring,
    {
      enabled: false,
    },
  )
  return itemsToBring
}

// add items to bring
const createItemsToBring = async (payload: {
  name: string
  iconId: string
}) => {
  const response = await axiosPost(payload, `v1/items-to-bring`)
  return response.data
}

export const useCreateItemsToBring = () => {
  const queryClient = useQueryClient()
  return useMutation(createItemsToBring, {
    onSuccess: (newItem: ItemsToBringListing) => {
      queryClient.setQueryData(
        ['items-to-bring-list'],
        (oldData: ItemsToBringListing[] | undefined) => {
          if (!oldData) return [newItem]
          return [...oldData, newItem]
        },
      )
    },
  })
}

// update item to bring
const updateItemsToBring = async ({
  itemToBringId,
  payload,
}: {
  itemToBringId: string
  payload: {
    name: string
    iconId: string
  }
}) => {
  const response = await axiosPatch(
    payload,
    `v1/items-to-bring/${itemToBringId}`,
  )
  return response.data
}

export const useUpdateItemsToBring = () => {
  const queryClient = useQueryClient()
  return useMutation(updateItemsToBring, {
    onSuccess: (updatedItem: ItemsToBringListing) => {
      queryClient.setQueryData(
        ['items-to-bring-list'],
        (oldData: ItemsToBringListing[] | undefined) => {
          if (!oldData) return [updatedItem]
          return oldData.map((item: ItemsToBringListing) =>
            item._id === updatedItem._id ? updatedItem : item,
          )
        },
      )
    },
  })
}

// delete items to bring
const deleteItemsToBring = async (itemId: string) => {
  const response = await axiosDelete(`v1/items-to-bring/${itemId}`)
  return response.data
}

export const useDeleteItemsToBring = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteItemsToBring, {
    onSuccess: (deletedItem: ItemsToBringListing) => {
      queryClient.setQueryData(
        ['items-to-bring-list'],
        (oldData: ItemsToBringListing[] | undefined) => {
          if (!oldData) return []
          return oldData.filter(
            (item: ItemsToBringListing) => item._id !== deletedItem._id,
          )
        },
      )
    },
  })
}
